const colors = [
  '#FFFFFF',
  '#F8F9FA',
  '#47d147',
  '#66FFFE',
  '#ffff66',
  '#ff471a',
  '#ff9900',
  '#cccccc',
  '#3399FF',
  '#bf00ff',
  '#222222'
]

export default colors
